var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 15.3125C9.375 21.1563 14.1562 25.9375 20 25.9375C25.8438 25.9375 30.625 21.1563 30.625 15.3125C30.625 9.46875 25.8438 4.6875 20 4.6875C14.1562 4.6875 9.375 9.46875 9.375 15.3125ZM28.125 15.3125C28.125 19.7813 24.4688 23.4375 20 23.4375C15.5312 23.4375 11.875 19.7813 11.875 15.3125C11.875 10.8437 15.5312 7.1875 20 7.1875C24.4688 7.1875 28.125 10.8437 28.125 15.3125Z",
    fill: "#FF2E63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 37.3125C10.9375 34 15.3125 32.1875 20 32.1875C24.6875 32.1875 29.0625 34 32.375 37.3125L34.1563 35.5312C30.375 31.7812 25.3437 29.6875 20 29.6875C14.6562 29.6875 9.625 31.7812 5.84375 35.5312L7.625 37.3125Z",
    fill: "#FF2E63"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2360bc4b12ec44ee8c22f293b895c71f.svg";
export { ForwardRef as ReactComponent };